const state = {
  lang: null,
};
const getters = {
  getLang: state => {
    if (state.lang == null) {
      let temp = sessionStorage.getItem('lang');
      if (temp != null) {
        state.lang = (temp == 'en' ? 'en' : 'zh');
      } else {
        state.lang = 'en';
        sessionStorage.setItem('lang', state.lang);
      }
    }
    return state.lang;
  }
};
const mutations = {
  SET_LANG(state, lang) {
    state.lang = (lang == 'en' ? 'en' : 'zh');
    sessionStorage.setItem('lang', state.lang);
  }
};
const actions = {
  setLang({
    commit
  }, lang) {
    commit('SET_LANG', lang);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/lang.js